import { ReactElement } from "react"
import { LinkProps } from "./link-props"
import * as S from './link-style'

export function Link ({ children, ...rest }: LinkProps): ReactElement {
  return <S.Container {...rest}>{children}</S.Container>
}